import React, { Suspense, lazy } from 'react';
import { UrgencyBar } from './UrgencyBar';
import { HeroSection } from './HeroSection';
import { ChangeSection } from './ChangeSection';
import { WhatsIncluded } from './WhatsIncluded';
import { InsidePreviewSection } from './InsidePreviewSection';
import { AudienceSection } from './AudienceSection';
import { TestimonialsSection } from './TestimonialsSection';
import { OfferStack } from './OfferStack';
import { BrandSection } from './BrandSection';
import { GuaranteeFAQSection } from './GuaranteeFAQSection';
import { FinalCTA } from './FinalCTA';
import { FooterSection } from './FooterSection';
import { StickyCTA } from './StickyCTA';

// Lazy-load the purchase notice so it stays out of the initial bundle
const PurchaseNotification = lazy(() => import('./PurchaseNotification').then(m => ({
  default: m.PurchaseNotification
})));
type SalesPageProps = {
  showTestimonials: boolean;
  showPurchaseNotifications: boolean;
};
export function SalesPage({
  showTestimonials,
  showPurchaseNotifications
}: SalesPageProps) {
  return <div className="min-h-screen w-full bg-ivory text-forest selection:bg-terracotta selection:text-ivory" data-id="element-193" data-mp="3sux61ezgn01g">
      <UrgencyBar data-id="element-194" data-mp="3nw2d3k7s3v3m" />
      <main data-id="element-195" data-mp="6h5di1ea6482">
        <HeroSection data-id="element-196" data-mp="6hounfw3wol1" />
        <ChangeSection data-id="element-197" data-mp="6i6yaxl3m52z" />
        <WhatsIncluded data-id="element-198" data-mp="6ji2gyigheum" />
        <InsidePreviewSection data-id="element-199" data-mp="1qozaf2myekn" />
        <AudienceSection data-id="element-200" data-mp="1pnma5227i0a" />
        {showTestimonials && <TestimonialsSection data-id="element-201" data-mp="1om1h8v8rh5d" />}
        <OfferStack data-id="element-202" data-mp="fhka3wwp35qv" />
        <BrandSection data-id="element-203" data-mp="fh26ugbm7r9g" />
        <GuaranteeFAQSection data-id="element-204" data-mp="fga8wyujphg0" />
        <FinalCTA data-id="element-205" data-mp="bgia3duyepnu" />
      </main>
      <FooterSection data-id="element-206" data-mp="bh9rnkrpumv4" />

      <StickyCTA data-id="element-207" data-mp="bfyq7rlqtr76" />
      {showPurchaseNotifications && <Suspense fallback={null} data-id="element-208" data-mp="pgt1ci06e69j">
          <PurchaseNotification data-id="element-209" data-mp="peyhl70n4k71" />
        </Suspense>}
    </div>;
}